<template>
	<div class="error-page-wrap">
		<header-component type="home" />
		<div>
			<div class="error-page-content">
				<img class="error-page-img" src="@/resources/images/error.png" alt="Pomogai" width="414" height="193" />
			</div>
			<div class="error-page-text-wrap">
				<p class="error-page-text">Я создан помогать, но сейчас доступ к сервису ограничен. Давай попробуем еще раз.</p>
			</div>
		</div>
		<base-button
			@click="toMain"
			class="error-page-btn"
			icon="arrow"
			:text="'На главную'"
			icon-position="left"
			variant="gradient"
		/>
	</div>
</template>

<script setup lang="ts">
import HeaderComponent from '@/components/HeaderComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

function toMain() {
	router.push('/')
}
</script>

<style lang="scss" scoped>
.error-page {
	&-sign {
		font: var(--font-display);
		color: var(--text-tertiary);
	}
	&-content {
		margin-top: 52px;
		@include flex-column-center;
	}
	&-img {
		margin-bottom: 20px;
	}
	&-title {
		font: var(--font-display);
		margin-bottom: 12px;
	}
	&-text {
		font: var(--font-heading);
		margin-bottom: 12px;
		color: var(--text-secondary);
	}
	&-text-wrap {
		width: 100%;
		max-width: 351px;
		text-align: center;
		margin: 0 auto;
	}
	&-wrap {
		height: calc(100svh - 106px);
		position: relative;
		@include flex-column-between;
	}
	&-btn {
		position: relative;
		left: 0;
		right: 0;
		margin: 0 auto;
		max-width: 200px;
	}
}
</style>
